import React, { Fragment, useEffect } from "react";
// import { useDispatch } from "react-redux";
import { seo } from "../../utils/utils";

const TermAndCondition = () => {
  // const dispatch = useDispatch();
  // const [privacyData, setPrivacyData] = useState({});

  // const PrivacyPolicySelector = useSelector(
  //   (state) => state.configurationSettingDetail
  // );

  // useEffect(() => {
  //   if (PrivacyPolicySelector?.result) {
  //     setPrivacyData(handleDetailResponse(PrivacyPolicySelector?.result?.data));
  //   }
  // }, []);

  // useEffect(() => {
  //   dispatch(getPrivacyPolicy());
  // }, [dispatch]);

  useEffect(() => {
    seo({
      title: "Term And Condition",
      metaDescription: "Term and condition",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <Fragment>
      <div className="page-body">
        <h3 className="mt-3 mb-2 ml-3">Terms And Condition</h3>
        {/* <div
          className="container-fluid"
          dangerouslySetInnerHTML={{ __html: privacyData?.text }}
        /> */}
      </div>
    </Fragment>
  );
};

export default TermAndCondition;
